module.exports = __webpack_public_path__ + "assets/img/bg.30fd6c66.png";